if (typeof window !== "undefined") {
    window.globalHistory = {
      replaceState: function (state, title, url) {
        if (window.history && typeof window.history.replaceState === "function") {
          return window.history.replaceState(state, title, url);
        }
        console.warn("window.history.replaceState is not available.");
      },
      pushState: function (state, title, url) {
        if (window.history && typeof window.history.pushState === "function") {
          return window.history.pushState(state, title, url);
        }
        console.warn("window.history.pushState is not available.");
      },
      get state() {
        return window.history ? window.history.state : null;
      },
    };
  }
  